export const text = {
  MyOpinion: "Mijn mening",
  Owner: "Eigenaar",
  Feedback: "Feedback",
  CreatedAt: "Aangemaakt op",
  AssignTo: "Toewijzen aan",
  MyOpinionFormupdatedsuccessfully:
    "Mijn Mening formulier succesvol bijgewerkt",
  AssignedTeam: "Toegewezen team",
  AssignTo: "Toewijzen aan",
  Public: "Openbaar",
  Team: "Team",
  MyOpinionForms: "Mijn Mening formulieren",
  MyOpinionFeedbackForm: "Mijn Mening feedbackformulier",
  AddForm: "Formulier toevoegen",
  FormName: "Formuliernaam",
  PleaseProvidetheFormName: "Geef de formuliernaam op",
  AddMyOpinionForm: "Mijn Mening formulier toevoegen",
  Addfieldsintheform: "Voeg velden toe aan het formulier",
  MyOpinionForm: "Mijn Mening formulier",
  Anonymous: "Anoniem",
  MyOpinionFormDeleted: "Mijn Mening formulier succesvol verwijderd",
  reactions: "Reacties",
};
